import IncidentListToolbar from '@/views/incident/toolbars/IncidentListToolbar';
import IncidentViewToolbar from '@/views/incident/toolbars/IncidentViewToolbar';
import IncidentView from '@/views/incident/IncidentView';
import IncidentList from '@/views/incident/IncidentList';
import DefaultLayout from '@/layout/DefaultLayout';
import { STATES } from '@/constants';

export const incidentDeletedRoutes = [
  {
    path: '/incident-deleted',
    name: 'incident-deleted',
    components: {
      default: IncidentList,
      toolbar: IncidentListToolbar
    },
    meta: {
      type: STATES.REMOVED,
      sortBy: 'UPDATED_AT',
      title: 'Удалённые обращения',
      layout: DefaultLayout
    }
  },
  {
    path: '/incident-deleted/:id',
    name: 'incident-deleted-view',
    components: {
      default: IncidentView,
      toolbar: IncidentViewToolbar
    },
    meta: {
      layout: DefaultLayout,
      type: STATES.REMOVED
    }
  },
  {
    path: '/incident-deleted/:id/more/:moreId?',
    name: 'incident-deleted-view-more',
    components: {
      default: IncidentView,
      toolbar: IncidentViewToolbar
    },
    meta: {
      layout: DefaultLayout,
      type: STATES.REMOVED
    }
  }
];
